import { YDatabase } from '@databases/collab/y-database';
import { ALL_ENTRIES_DATABASE_VIEW } from '@databases/types/database/view';

import { viewHasChanges } from '../../../database/view/view';
import { collabViewToDatabaseView } from '../convert-to-database';

/**
 * Saves old all entries view if modified, deletes if not, and adds a new one if it doesn't exist.
 */
export function sanitizeViews(documentId: string, ydb: YDatabase): void {
  for (const viewId of ydb.views) {
    if (ydb.viewsById[viewId].name.toLowerCase() === 'all entries') {
      if (
        viewHasChanges(
          collabViewToDatabaseView(viewId, ydb.viewsById[viewId].toJSON()).settings,
          ALL_ENTRIES_DATABASE_VIEW.settings
        )
      ) {
        const view = ydb.viewsById[viewId];
        view.applyNameDelta([{ retain: 'all entries'.length }, { insert: ' (edited)' }]);
      } else {
        ydb.deleteView(viewId);
      }
    }
  }
}
